import React from 'react';
import { Component } from "react";
import { API_URL } from '../urls';
import {Form} from "react-bootstrap";
import {Button} from "react-bootstrap";
import { Editor } from '@tinymce/tinymce-react';
import DefaultLayout from "../layouts/Default";
require('odatajs');

class EditStaticPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      pending: true,
      data: null,
      id: props.match.params.id
    };
  }

  componentDidMount() {
    document.title = "Edit static page";
      window.odatajs.oData.read(API_URL + "StaticPages(" + this.state.id + ")",
            (data) => {
          	this.setState({
	            pending: false,
        	    data
	        });
            },
            (error) => {
                if(error.response.statusCode === 401){
                  window.location.href = "/login";
                }
          	this.setState({
	            pending: false,
        	    error
	        });
            }
        );
    }

  save(e) {
    e.preventDefault();
    let token = localStorage.getItem('_TOKEN_AUTH');
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json', Authorization: "Bearer " + token };
    var request = {
        requestUri: API_URL + "StaticPages(" + this.state.id + ")",
        method: 'PUT',
        headers: headers,
        data: this.state.data
    };
    window.odatajs.oData.request(
        request,
        (data, response) => {
          window.location.href = "/pages/" + this.state.data.Id; 
        },
        (err) => {
            alert('Fail: ' + err.message);
        }
    );    
  }

    render() { 
	const { error, pending } = this.state;
	if (error) {
      		return <div>Error: {error.message}</div>;
	} else if (pending) {
		return <div>Loading...</div>;
	} else {
	        return (
<DefaultLayout>
<Form onSubmit={(e) => this.save(e)}>
<Form.Group>
    <Form.Label htmlFor="">Title</Form.Label>
    <Form.Control
      type="text" id="" placeholder="Enter the page title" aria-describedby="HelpBlock"
      value={this.state.data?.Name} onChange={(e) => { let data = this.state.data; data.Name = e.target.value; this.setState({ data });}}
    />
    <Form.Text id="HelpBlock" muted>Title of the page to show in the browser</Form.Text>
  </Form.Group>
  <Form.Group>
    <Form.Label htmlFor="">Page body</Form.Label>
    <Editor
         initialValue="<p>This is the initial content of the editor</p>"
         init={{
           height: 500,
           menubar: true,
           plugins: [
            "advlist autolink lists link image charmap print preview anchor",
            "searchreplace visualblocks code fullscreen",
            "insertdatetime media table paste",
          ],
          toolbar:
            "undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image",
          }}
         value={this.state.data.Body}
         onEditorChange={(content, editor) => { let data = this.state.data; data.Body = content; this.setState({ data });}}
       />
       <Form.Text id="HelpBlock" muted>Specify page body</Form.Text>

  </Form.Group>
  <Button type="submit">Save</Button>

</Form>
</DefaultLayout>
		);
	}
    }
}
 
export default EditStaticPage;